import { onMounted, onUnmounted, watch } from 'vue'
import { useDeviceStore } from '@/stores/device'
import { ReportEvents } from '@rapoo/device-sdk'
import { storeToRefs } from 'pinia'

export const useRTReport = (cb: (data: any) => void) => {
  const deviceStore = useDeviceStore()
  const { currentDevice } = storeToRefs(deviceStore)

  const setup = () => {
    if (!currentDevice.value) return
    currentDevice.value.on(ReportEvents.KeyRtSwitch, cb)
  }

  const teardown = () => {
    if (!currentDevice.value) return
    currentDevice.value.off(ReportEvents.KeyRtSwitch, cb)
  }

  onMounted(setup)
  onUnmounted(teardown)

  watch(
    () => currentDevice.value,
    (newVal, oldVal) => {
      if (oldVal) oldVal.off(ReportEvents.KeyRtSwitch, cb)
      if (newVal) newVal.on(ReportEvents.KeyRtSwitch, cb)
    },
  )
}
